module.exports = __webpack_public_path__ + "media/images/estate_owners/img_01-5d66607bbda63ad7967292cd4c506d4f.png";